import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  AbstractMenuProvider,
  PartialMenuSection,
} from '../menu-provider.model';
import { ExternalLinkMenuItemModel } from '../menu-item/models/external-link.model';

/**
 * Menu provider to create a \"Repository User Guide\" external link
 * in the public navbar, next to the Browse section.
 */
@Injectable()
export class RepositoryUserGuideMenuProvider extends AbstractMenuProvider {

  public getSections(): Observable<PartialMenuSection[]> {
    const model = new ExternalLinkMenuItemModel();
    model.text = 'menu.section.repository_user_guide';
    model.href = 'https://twc-hk.libguides.com/institutional-repository';

    return of([
      {
        visible: true,
        model,
        icon: 'book-open',
      },
    ]);
  }
}

